import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { memo } from 'react/cjs/react.production.min';

import { liveConnection } from './liveConnection';

export const SocketConnection = memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    liveConnection.handleRouteChange(pathname).then((connectionData) => {
      liveConnection.connectionInitCallback(connectionData);
    });
  }, [pathname]);

  return null;
});
